import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';
import { isProductOneOf } from './is-product-one-of';

/**
 * Eligibility for Premium predunning PaymentFlowLink (Jira/JSM/JPD in predunning with experience URL).
 */
export function isEligibleForJiraPremiumPredunning(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		isInPredunning,
		canAddPaymentDetails,
		addPaymentDetailsExperienceUrl,
		isInCollection,
		invoiceableStatus,
	} = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['premium']) &&
		isInPredunning &&
		isProductOneOf(product, ['jira', 'jira-service-management', 'jira-product-discovery']) &&
		canAddPaymentDetails &&
		addPaymentDetailsExperienceUrl &&
		invoiceableStatus === 'NOT_INVOICEABLE',
	);
}
